import { environment } from '../../../../environments/environment';

export const API_BASE_URL = environment.otherApis.apiBaseElite + '/api';
export const API_COBOT_URL = environment.otherApis.cobot;
export const API_COBOT_INFERENCE_URL = environment.otherApis.cobot.replace(
  '/cobot-ai',
  '/inference'
);
export const API_COBOT_TRAIN_URL = environment.otherApis.cobot.replace(
  '/cobot-ai',
  '/train'
);
export const API_ENDPOINTS = {
  ASSEMBLY_ITEMS: `${API_BASE_URL}/assembly-items`,
  BATCH: `${API_BASE_URL}/batch`,
  COMPOUNDING: `${API_BASE_URL}/compounding`,
  CUTTING_ORDERS: `${API_BASE_URL}/cutting-orders`,
  DEPARTMENTS: `${API_BASE_URL}/departments`,
  FINISHED_TYPES: `${API_BASE_URL}/finishing-types`,
  HOSES: `${API_BASE_URL}/hoses`,
  HR: `${API_BASE_URL}/hr`,
  INSPECTIONS: `${API_BASE_URL}/inspections`,
  ITEM_MEASURES: `${API_BASE_URL}/item-measures`,
  LABELS: `${API_BASE_URL}/label`,
  LIDS: `${API_BASE_URL}/lids`,
  MACHINES: `${API_BASE_URL}/machines`,
  MACHINING: `${API_BASE_URL}/machining`,
  MAINTENANCE: `${API_BASE_URL}/maintenance`,
  MANAGEMENT: `${API_BASE_URL}/management`,
  MOLD_LOCATIONS: `${API_BASE_URL}/mold-locations`,
  MOLDS: `${API_BASE_URL}/molds`,
  MOLD_ORDERS: `${API_BASE_URL}/mold-orders`,
  ORDER_USERS: `${API_BASE_URL}/orders-users`,
  PACKING_BOX: `${API_BASE_URL}/packing-box`,
  PALLETS: `${API_BASE_URL}/pallets`,
  PARTS: `${API_BASE_URL}/parts`,
  PLEATS: `${API_BASE_URL}/pleats`,
  PROGRESS_REPORT: `${API_BASE_URL}/progress-report`,
  PROJECTS: `${API_BASE_URL}/projects`,
  REPORTS: `${API_BASE_URL}/reports`,
  RESOURCES: `${API_BASE_URL}/resources`,
  ROLES: `${API_BASE_URL}/roles`,
  ROTOLINE_CYCLES: `${API_BASE_URL}/cycles`,
  SCHEDULER_PROCESS: `${API_BASE_URL}/scheduler-process`,
  SCHEDULER: `${API_BASE_URL}/scheduler`,
  SCRAP_REASONS: `${API_BASE_URL}/scrap-reasons`,
  SUB_ORDER: `${API_BASE_URL}/subWorkOrder`,
  SHIFTS: `${API_BASE_URL}/shifts`,
  STAGES: `${API_BASE_URL}/stages`,
  TASKS: `${API_BASE_URL}/task`,
  USERS: `${API_BASE_URL}/users`,
  WORK_ORDER_GROUP: `${API_BASE_URL}/work-order/group`,
  WORK_ORDERS: `${API_BASE_URL}/work-orders`,
  CAUSAS_SCRAP: `${API_BASE_URL}/causas-scrap`,
  SHIPING_REFUND: `${API_BASE_URL}/shipping-and-refund`,
  DEAD_TIMES: `${API_BASE_URL}/dead-times`,
  DEAD_TIMES_ARMS_MACHINES: `${API_BASE_URL}/deadtimes-on-arm-machines`,
  DEAD_TIMES_REPORTS: `${API_BASE_URL}/reports-dead-times`,
  COC: `${API_BASE_URL}/cocs`,
  SHIPMENT: `${API_BASE_URL}/shipment`,
  JOB_POSITION: `${API_BASE_URL}/job-positions`,
  QUALITY_ALERTS: `${API_BASE_URL}/quality-alerts`,
};
